import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id/runs")({
  component: Outlet,
});
